import { render } from "./hero.vue?vue&type=template&id=c682343a&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=c682343a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c682343a"

export default script